import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// import auth_he from './Languages/auth/he';
// import auth_en from './Languages/auth/en';
// import auth_ar from './Languages/auth/ar';
// import login_he from './Languages/Login/he';
// import login_en from './Languages/Login/en';
// import login_ar from './Languages/Login/ar';

// import bot_he from './Languages/Bot/he';
// import bot_en from './Languages/Bot/en';
// import bot_ar from './Languages/Bot/ar';

// import register_he from './Languages/Register/he';
// import register_en from './Languages/Register/en';
// import register_ar from './Languages/Register/ar';


import consentformHe from "../Languages/Consentform/Consentform.he";
import consentformEn from "../Languages/Consentform/Consentform.en";
import consentformAr from "../Languages/Consentform/Consentform.ar";

// import about_he from '../Languages/About/about.he';
// import about_en from '../Languages/About/about.en';
// import about_ar from '../Languages/About/about.ar';

// import chatbot_he from './Languages/chatbot/he';
// import chatbot_en from './Languages/chatbot/en';
// import chatbot_ar from './Languages/chatbot/ar';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      he: {
        // register:register_he,
        //  login: login_he,
         consentform: consentformHe,
        // about: about_he,
        // bot: bot_he
        // chatbot: chatbot_he,
      },
      en: {
        // register:register_en,
        // login: login_en,
        consentform: consentformEn,
        // about: about_en,
        // bot: bot_en
        // chatbot: chatbot_en,
      },
      ar: {
        // register:register_ar,
        // login: login_ar,
        consentform: consentformAr,
        // about: about_ar,
        //  bot: bot_ar
        // chatbot: chatbot_ar,
      },
    },
    fallbackLng: 'he',
    defaultNS: 'auth',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'he' || lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);
});

export default i18n;